import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-ce5c54e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex main" }
const _hoisted_2 = { class: "form-container d-flex flex-column justify-content-center pb-4 align-items-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Logo"
}, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "bold-h3 text-center px-10" }, "Acesse a plataforma Locates", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "informative-form regular-p" }, " Insira as informações abaixo para concluir o login ", -1))
const _hoisted_6 = { class: "login-form" }
const _hoisted_7 = { class: "informative-checkbox-container" }
const _hoisted_8 = { class: "lcts-button" }
const _hoisted_9 = { class: "informative-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "informative-item-1 regular-p" }, "Não possui conta? ", -1))
const _hoisted_11 = { class: "informative-item-2 bold-p" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Cadastre-se", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginCarousel = _resolveComponent("LoginCarousel")!
  const _component_InputTextfield = _resolveComponent("InputTextfield")!
  const _component_Password = _resolveComponent("Password")!
  const _component_InputCheckbox = _resolveComponent("InputCheckbox")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_LoginCarousel, { class: "hide-on-mobile" }),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("form", _hoisted_6, [
        _createVNode(_component_InputTextfield, {
          onLctsInputTextFieldValue: _ctx.handleInputEmailValue,
          onLctsInputTextFieldIsValid: _ctx.handleInputEmailIsValid,
          type: "email",
          id: "email",
          name: "email",
          textPlaceholder: "Informe seu e-mail",
          width: "100%",
          height: "auto",
          modelValue: _ctx.form.username,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.username) = $event)),
          showError: _ctx.showError,
          isRequired: true,
          validator: "email"
        }, null, 8, ["onLctsInputTextFieldValue", "onLctsInputTextFieldIsValid", "modelValue", "showError"]),
        _createVNode(_component_Password, { onValuePasswordChange: _ctx.handleInputPasswordValue }, null, 8, ["onValuePasswordChange"]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_InputCheckbox, {
            onLctsCheckboxChanged: _ctx.handleCheckboxChange,
            class: "regular-label",
            text: "Lembrar de mim"
          }, null, 8, ["onLctsCheckboxChanged"]),
          _createVNode(_component_RouterLink, {
            to: { name: 'forgot-password' },
            class: "informative-checkbox-forgot-password regular-label"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Esqueci minha senha")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_Button, {
            onLctsButtonClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleButtonClick(_ctx.form))),
            size: "large",
            styleButton: "secondary",
            text: "Entrar",
            width: "100%",
            disabled: !_ctx.isFormValid()
          }, null, 8, ["disabled"])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("label", _hoisted_11, [
          _createVNode(_component_RouterLink, {
            to: { name: 'register' },
            class: "informative-item-2"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}